import React, { useState, useEffect } from 'react';
import { AsyncPaginate } from 'react-select-async-paginate';
import { useAuth } from '../contexts/AuthContext';
import { CFormLabel } from '@coreui/react';
import { useChoice } from '../contexts/ChoicesContext';

function ChoiceSelection({ value, onChange, className, labelClassName, multiSelect = true, required = false, error = false, disabled = false }) {
    const requiredIcon = required ? <span className="text-danger">*</span> : null;

    const { restaurantId } = useAuth();
    const { getAllChoices } = useChoice();

    const [totalRenderedRecords, setTotalRenderedRecords] = useState(0);
    const [key, setKey] = useState(0);
    const [filter, setFilter] = useState({
        restaurant_id: restaurantId,
        limit: 50,
        totalRenderedRecords: totalRenderedRecords,
        filter: null,
    });

    useEffect(() => {
        if (restaurantId) {
            setFilter({ ...filter, restaurant_id: restaurantId });
        }
    }, [restaurantId]);

    useEffect(() => {
        setKey((prevKey) => prevKey + 1);
    }, [restaurantId]);

    const fetchChoices = async (searchValue, loadedOptions, { totalRenderedRecords }) => {
        try {
            if (restaurantId) {
                const response = await getAllChoices({ ...filter, filter: searchValue, totalRenderedRecords });

                if (response.totalPages > 0) {
                    const newOptions = response.choices.length > 0 && response.choices.map((choice) => ({
                        label: choice.name,
                        value: choice.id,
                    }));

                    const hasMore = totalRenderedRecords + newOptions.length < response.totalCount;

                    return {
                        options: newOptions,
                        hasMore: hasMore,
                        additional: {
                            totalRenderedRecords: totalRenderedRecords + filter.limit,
                        },
                    };
                } else {
                    return {
                        options: [],
                        hasMore: false,
                        additional: null,
                    };
                }
            }
        } catch (error) {
            console.error('Error fetching choices', error);
            return {
                options: [],
                hasMore: false,
                additional: null,
            };
        }
    };

    const customStyles = {
        option: (provided, state) => ({
            ...provided,
            whiteSpace: state.isFocused ? 'pre-wrap' : 'nowrap',
            wordBreak: state.isFocused ? 'break-all' : null,
            wordWrap: state.isFocused ? 'break-word' : null,
            overflow: 'hidden',
            textOverflow: 'ellipsis',
        }),
    };

    return (
        <div key={key} className={className}>
            <div className={labelClassName}>
                <CFormLabel>Choice {requiredIcon}</CFormLabel>
            </div>
            <div className='w-100'>
                <AsyncPaginate
                    className={`${(error && required) && 'multiSelect_error'} `}
                    value={value}
                    loadOptions={fetchChoices}
                    isMulti={multiSelect}
                    closeMenuOnSelect={!multiSelect ? true : false}
                    onChange={onChange}
                    isDisabled={disabled}
                    placeholder='Select choice...'
                    noOptionsMessage={() => ('No choices found')}
                    loadingMessage={() => ('Choices Loading...')}
                    additional={{
                        totalRenderedRecords: totalRenderedRecords,
                    }}
                    SelectProps={{
                        isSearchable: true,
                    }}
                    menuShouldScrollIntoView={false}
                    menuPortalTarget={document.querySelector('body')}
                    styles={customStyles}
                />
                {(error && required) && <span className="text-danger error_message">Please select any one choice.</span>}
            </div>
        </div>
    );
}

export default ChoiceSelection;
